import {CookieHelper} from "../modules/CookieHelper";

class LinkedModalHandler
{
    constructor() {
        this.showModals();
        this.initListeners();
    }

    showModals() {
        if (!CookieHelper.getCookie('price_incl_vat')) {
            this.showPriceModal();

            return;
        }

        this.showDynamicModal();

        if (!CookieHelper.getCookie('newsletter')) {
            setTimeout(() => {
                this.showNewsletterToast();
            }, 150);
        }
    }

    initListeners() {
        const pp_switch_radio_buttons = document.querySelectorAll(
            "input[type=radio].pp-switch"
        );

        if (0 === pp_switch_radio_buttons.length) {
            return;
        }

        Array.from(pp_switch_radio_buttons).forEach(pp_switch_radio_button => {
            pp_switch_radio_button.addEventListener('change', evt => {
                const value = evt.target.value;

                CookieHelper.setCookie('price_incl_vat', value, 365);

                $("#pp-modal").modal('hide');

                location.reload();
            });
        });
    }

    showPriceModal() {
        if (CookieHelper.getCookie('price_incl_vat')) {
            return;
        }

        const $modal = $("#pp-modal");
        $modal.modal('show');
        $modal.on('hidden.bs.modal', function () {
            location.reload();
        });
    }

    showNewsletterToast() {
        if (!CookieHelper.getCookie('price_incl_vat') || CookieHelper.getCookie('newsletter')) {
            return;
        }

        const $toast = $("#newsletter-toast");
        $toast.toast('show');
        $toast.on('hidden.bs.toast', event => {
            CookieHelper.setCookie('newsletter', true, 30);
        });
    }

    showDynamicModal() {
        const $modal = $("#dynamic-modal");
        if (!$modal.length || sessionStorage.getItem('dynamic-modal-shown')) {
            return;
        }

        $modal.modal('show');

        $modal.on('shown.bs.modal', function () {
            const $iframe = $(this).find("iframe#dynamic-modal-video");

            if (!$iframe.length) {
                return;
            }

            const url = $iframe.attr('data-src');
            $iframe.attr('src', url);
        });

        $modal.on('hidden.bs.modal', function () {
            sessionStorage.setItem('dynamic-modal-shown', true);

            const $iframe = $(this).find("iframe#dynamic-modal-video");

            if (!$iframe.length) {
                return;
            }

            $iframe.attr('src', '');
        });

        $('#dynamic-modal-button').on('click', function(event){
            event.preventDefault();

            const targetUrl = $(this).attr('href');
            sessionStorage.setItem('dynamic-modal-shown', true);

            window.location.href = targetUrl;
        });
    }
}

$(document).ready(function () {
    new LinkedModalHandler();
});

